import { type SelectListItem } from '@resources/js/typings/viewModels/selectListItemViewModel';
import React, { type MouseEvent, type JSX } from 'react';
import LinkWrapper from '../LinkWrapper/LinkWrapper';

type SelectLinkOptionWrapperProps = {
  option: SelectListItem<string | number | null>;
  children: React.ReactNode;
  navigate?: (
    event: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
  ) => void | Promise<void>;
};

export default function SelectLinkOptionWrapper({
  option,
  children,
  navigate,
}: SelectLinkOptionWrapperProps): JSX.Element {
  return option.url ? (
    // We know the Select component will set the href
    <LinkWrapper href={option.url} onClick={navigate} scroll={false}>
      <span>{children}</span>
    </LinkWrapper>
  ) : (
    <>{children}</>
  );
}
